import React from "react";
import { Dayjs } from "dayjs";

export interface OpenedView {
	creationTime: Dayjs;
	viewKey: string;
}

export interface OpenedViewsContextValue {
	openedViews: OpenedView[];
	addOpenedView: (viewKey: string) => void;
}

export const OpenedViewsContext = React.createContext<OpenedViewsContextValue | undefined>(undefined);
